import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  reset,
  resetState,
  sendAdministrationBiodata,
} from "../../features/administration/administrationSlice";
import useEffectOnce from "../../helpers/useEffectOnce";

const Form = () => {
  const dispatch = useDispatch();

  const genderOptions = [
    { value: "0", label: "Tidak ingin memberi tahu" },
    { value: "1", label: "Laki-laki" },
    { value: "2", label: "Perempuan" },
  ];

  //   const occupationList = [
  //     { value: "", label: "-" },
  //     { value: "Karyawan Swasta", label: "Karyawan Swasta" },
  //     { value: "Wirausaha", label: "Wirausaha" },
  //     { value: "Buruh Harian Lepas", label: "Buruh Harian Lepas" },
  //     { value: "Lainnya", label: "Lainnya" },
  //   ];

  //   const educationList = [
  //     { value: "", label: "-" },
  //     { value: "Tamat SD", label: "Tamat SD / Sederajat" },
  //     { value: "SLTP", label: "Tamat SMP / SLTP / Sederajat" },
  //     { value: "SLTA", label: "Tamat SMA / SMK / SLTA / Sederajat" },
  //     { value: "Lainnya", label: "Lainnya" },
  //   ];

  //   const incomeList = [
  //     { value: "", label: "-" },
  //     {
  //       value: "Rp1.000.000 s/d Rp2.000.000",
  //       label: "Rp1.000.000 s/d Rp2.000.000",
  //     },
  //     {
  //       value: "Rp2.000.001 s/d Rp3.000.000",
  //       label: "Rp2.000.001 s/d Rp3.000.000",
  //     },
  //     {
  //       value: "Rp3.000.001 s/d Rp4.000.000",
  //       label: "Rp3.000.001 s/d Rp4.000.000",
  //     },
  //     {
  //       value: "Rp4.000.001 s/d Rp5.000.000",
  //       label: "Rp4.000.001 s/d Rp5.000.000",
  //     },
  //   ];

  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const [isAdministrationAccepted, setisAdministrationAccepted] =
    useState(false);

  const [administrationBiodata, setAdministrationBiodata] = useState({
    full_name: "",
    email: "",
    nin: "",
    birth_place: "",
    birth_date: "",
    phone: "",
    gender: "",
    nsn: "",
    company_name: "",
    department: "",
  });

  //   const [administrationFamilial, setAdministrationFamilial] = useState({
  //     father_name: "",
  //     father_occupation: "",
  //     father_income: "",
  //     mother_name: "",
  //     mother_occupation: "",
  //     mother_income: "",
  //     occupation: "",
  //     income: "",
  //     living_partner: "",
  //     financier: "",
  //   });

  //   const [administrationFiles, setAdministrationFiles] = useState({
  //     photo: null,
  //     nin_card: null,
  //     family_card: null,
  //     certificate: null,
  //     transcript: null,
  //     recommendation_letter: null,
  //     integrity_pact: null,
  //   });

  //   const [administrationDegree, setAdministrationDegree] = useState({
  //     degree: "",
  //   });

  const {
    full_name,
    email,
    nin,
    phone,
    birth_place,
    birth_date,
    gender,
    nsn,
    company_name,
    department,
  } = administrationBiodata;

  const { isLoading, data, message, isError, isSuccess } = useSelector(
    (state) => state.administration
  );

  const { user } = useSelector((state) => state.profile);

  const { administration_id } = data;

  const onFormChangeAdministrationBiodata = (e) => {
    setAdministrationBiodata((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    document.title = "LMS M-Knows | Administrasi";
  });

  const onFormSubmitBiodata = (e) => {
    e.preventDefault();
    if (data?.is_approved)
      return toast.warning(
        "Anda tidak dapat merubah data administrasi karena administrasimu sudah dikonfirmasi!"
      );

    if (
      Object.values(administrationBiodata).some((el, index) => {
        let index_optional = [
          //   "study_program",
          //   "semester",
          // "nin",
          //   "university_of_origin",
          //   "residence_address",
          // "company_name",
          // "department",
          //   "education",
          //   "nin_address",
          // "birth_place",
          // "birth_date",
          // "phone",
          // "gender",
          // "full_name",
          // "email",
          "nsn",
          "company_name",
          "department",
        ];

        let name_index = Object.keys(administrationBiodata)[index];
        if (index_optional.includes(name_index)) return false;
        if (administrationBiodata[name_index] === "") return true;

        return el === null;
      })
    )
      // return toast.error("jskajksaj");
      // console.log(administrationBiodata);

      dispatch(resetState());
    dispatch(
      sendAdministrationBiodata({ ...administrationBiodata, administration_id })
    );
  };

  useEffectOnce(() => {
    setIsPageLoaded(false);
    dispatch(resetState());
  });

  useEffect(() => {
    if (data?.is_approved) setisAdministrationAccepted(true);

    if (message && isError) {
      toast.error(
        "Masih ada field yang kosong atau tidak valid. Mohon isi semua field!"
      );
      dispatch(reset());
    }

    if (message && isSuccess && !isError) {
      toast.success(message);
      dispatch(reset());
    }

    if (Object.values(data).length !== 0) {
      setIsPageLoaded(true);

      let appendData = {};
      // if (data?.gender === null) appendData.gender = "0";
      if (data?.full_name === null) appendData.full_name = user.full_name;
      if (data?.email === null) appendData.email = user.email;
      if (data?.gender === null) appendData.gender = "";
      if (data?.phone === null) appendData.phone = "";
      if (data?.nin === null) appendData.nin = "";
      if (data?.birth_date === null) appendData.birth_date = "";
      if (data?.birth_place === null) appendData.birth_place = "";
      if (data?.nsn === null) appendData.nsn = "";
      if (data?.company_name === null) appendData.company_name = "";
      if (data?.department === null) appendData.department = "";

      if (data && Object.values(administrationBiodata).some((el) => el === ""))
        setAdministrationBiodata({
          ...data,
          ...appendData,
        });
      //   if (data?.familial) setAdministrationFamilial(data.familial);
      //   if (data?.files) {
      //     for (const [key, value] of Object.entries(data.files)) {
      //       if (value?.startsWith("documents/administrations/")) {
      //         setAdministrationFiles((prevState) => ({
      //           ...prevState,
      //           [key]: { name: value },
      //         }));
      //       }
      //     }
      //   }
      //   if (data?.degree) setAdministrationDegree({ degree: data.degree });
    }
  }, [data, isLoading, isPageLoaded, message]);

  return (
    <>
      {!isPageLoaded && isLoading ? (
        <>
          <span className="d-block text-center py-1 mt-1 mb-3 border">
            <div className="spinner-border">
              <span className="visually-hidden">Loading...</span>
            </div>
          </span>
          {/* <span className="d-block bg-light text-center py-1 mt-1 mb-3 border">
            <div className="spinner-border">
              <span className="visually-hidden">Loading...</span>
            </div>
          </span>
          <span className="d-block bg-light text-center py-1 mt-1 mb-3 border">
            <div className="spinner-border">
              <span className="visually-hidden">Loading...</span>
            </div>
          </span>
          <span className="d-block bg-light text-center py-1 mt-1 mb-3 border">
            <div className="spinner-border">
              <span className="visually-hidden">Loading...</span>
            </div>
          </span> */}
        </>
      ) : (
        <>
          <div className="accordion-item mb-3">
            <div className="accordion-body mt-3">
              <form onSubmit={onFormSubmitBiodata}>
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label">
                      <span className="text-danger">
                        <sup>*</sup>
                      </span>{" "}
                      Nama Lengkap
                    </label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="full_name"
                      value={full_name}
                      placeholder="Nama Lengkap"
                      onChange={onFormChangeAdministrationBiodata}
                      readOnly={isLoading}
                      disabled={isLoading || isAdministrationAccepted}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      <span className="text-danger">
                        <sup>*</sup>
                      </span>{" "}
                      Jenis Kelamin
                    </label>
                    <select
                      className="form-select mb-3"
                      onChange={onFormChangeAdministrationBiodata}
                      readOnly={isLoading}
                      disabled={isLoading || isAdministrationAccepted}
                      name="gender"
                      value={gender}
                      required
                    >
                      {genderOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      <span className="text-danger">
                        <sup>*</sup>
                      </span>{" "}
                      NIK
                    </label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="nin"
                      value={nin}
                      placeholder="Nomor Induk Karyawan"
                      onChange={onFormChangeAdministrationBiodata}
                      readOnly={isLoading}
                      disabled={isLoading || isAdministrationAccepted}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      <span className="text-danger">
                        <sup>*</sup>
                      </span>{" "}
                      Nomor Handphone
                    </label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="phone"
                      value={phone}
                      placeholder="Nomor Handphone"
                      onChange={onFormChangeAdministrationBiodata}
                      readOnly={isLoading}
                      disabled={isLoading || isAdministrationAccepted}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      <span className="text-danger">
                        <sup>*</sup>
                      </span>{" "}
                      Tempat Lahir
                    </label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="birth_place"
                      value={birth_place}
                      placeholder="Tempat Lahir"
                      onChange={onFormChangeAdministrationBiodata}
                      readOnly={isLoading}
                      disabled={isLoading || isAdministrationAccepted}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      <span className="text-danger">
                        <sup>*</sup>
                      </span>{" "}
                      Tanggal Lahir
                    </label>
                    <input
                      type="date"
                      className="form-control mb-3"
                      min="1901-01-01"
                      max="2099-12-31"
                      name="birth_date"
                      value={birth_date}
                      placeholder="dd/mm/yy"
                      onChange={onFormChangeAdministrationBiodata}
                      readOnly={isLoading}
                      disabled={isLoading || isAdministrationAccepted}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      <span className="text-danger">
                        <sup>*</sup>
                      </span>{" "}
                      Alamat Email
                    </label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="email"
                      value={email}
                      placeholder="Alamat Email"
                      onChange={onFormChangeAdministrationBiodata}
                      readOnly={isLoading}
                      disabled={isLoading || isAdministrationAccepted}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Nomor Induk Karyawan</label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="nsn"
                      value={nsn}
                      placeholder="Nomor Induk Karyawan"
                      onChange={onFormChangeAdministrationBiodata}
                      readOnly={isLoading}
                      disabled={isLoading || isAdministrationAccepted}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Nama Perusahaan</label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="company_name"
                      value={company_name}
                      placeholder="Nama Perusahaan"
                      onChange={onFormChangeAdministrationBiodata}
                      readOnly={isLoading}
                      disabled={isLoading || isAdministrationAccepted}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Devisi atau Unit Kerja</label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      name="department"
                      value={department}
                      placeholder="Devisi atau Unit Kerja"
                      onChange={onFormChangeAdministrationBiodata}
                      readOnly={isLoading}
                      disabled={isLoading || isAdministrationAccepted}
                    />
                  </div>
                </div>
                <div className="d-sm-flex justify-content-end mt-2">
                  {isLoading ? (
                    <button
                      className="btn btn-primary mb-0"
                      type="submit"
                      disabled={isLoading}
                    >
                      <span className="spinner-border spinner-border-sm"></span>
                      &nbsp;Loading...
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-primary mb-0"
                      disabled={isLoading || isAdministrationAccepted}
                    >
                      Simpan Biodata
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Form;
